import type { Pca } from '@/types/me'

import Tanguy from '@/assets/img/avatars/tanguy.png'
import TanguyStroobants from '@/assets/img/avatars/tanguy_stroobants.jpg'

import { brokerIsStroobants } from './brokers'

export const pca = (pca: Pca | null): advisor => {
  if (pca) {
    if (pca.pcaEmail === 'hello@yago.be')
      return {
        name: 'Tanguy Bocquet',
        avatar: Tanguy,
        email: pca.pcaEmail
      }
    else
      return {
        name: `${pca.pcaFirstName} ${pca.pcaLastName}`,
        avatar: pca.pcaPictureUrl,
        email: pca.pcaEmail
      }
  } else if (brokerIsStroobants())
    return {
      name: 'Tanguy Stroobants',
      avatar: TanguyStroobants,
      email: 'tanguy@stroobantsassurances.be'
    }
  else
    return {
      name: 'Tanguy Bocquet',
      avatar: Tanguy,
      email: 'tanguy.bocquet@yago.be'
    }
}

export interface advisor {
  name: string
  avatar: string
  email: string
}
